module.exports = {
          srcSet: __webpack_public_path__ + "663d9a5593e21f23b2360a273412085a-274.png"+" 274w",
          images:[ {path: __webpack_public_path__ + "663d9a5593e21f23b2360a273412085a-274.png",width: 274,height: 505}],
          src: __webpack_public_path__ + "663d9a5593e21f23b2360a273412085a-274.png",
          toString:function(){return __webpack_public_path__ + "663d9a5593e21f23b2360a273412085a-274.png"},
          
          width: 274,
          height: 505
        }